import React from 'react'
import PropTypes from 'prop-types'

import { SessionTableHead } from '../components/Table/data'
import AddIcon from '@mui/icons-material/Add'
import BodyContainer from '../components/bodyContainer'

const GestionSessions = ({
  fetchData,
  isLoadingSessionsList,
  sessions,
  sessionsCount,
  errorMessage,
  removeError,
  isErrorFetch,
  pageLimitChanged,
  pageChanged,
  success,
  isSuccessRefresh,
  resetSuccessAction,
  searchData,
  onCloseReset,
  fetchSessionById,
  objectModeDisplay,
}) => {
  return (
    <BodyContainer
      //EtatdisplayMode
      isDisplayMode={true}
      objectModeDisplay={objectModeDisplay}
      //CardMode
      titleButton={'session'}
      iconButtonCreate={<AddIcon sx={{ fontSize: 20 }} />}
      //TableMode
      actionButton={true}
      tableHead={SessionTableHead}
      //Commonfields
      globalID={'Sessions'}
      searchPlaceholder={'Rechercher par session'}
      title={'Gestion sessions'}
      fetchData={fetchData}
      loadingData={isLoadingSessionsList}
      dataList={sessions}
      countData={sessionsCount}
      errorMessage={errorMessage}
      removeError={removeError}
      removeErrorConfig={() => {}}
      isErrorFetch={isErrorFetch}
      pageLimitChanged={pageLimitChanged}
      pageChanged={pageChanged}
      searchData={searchData}
      onCloseReset={onCloseReset}
      fetchDataById={fetchSessionById}
      resetSuccessAction={resetSuccessAction}
      success={success}
      isSuccessRefresh={isSuccessRefresh}
      isSession={true}
    />
  )
}
GestionSessions.propTypes = {
  fetchData: PropTypes.func,
  isLoadingSessionsList: PropTypes.bool,
  sessions: PropTypes.array,
  sessionsCount: PropTypes.number,

  errorMessage: PropTypes.string,
  removeError: PropTypes.func,
  isErrorFetch: PropTypes.bool,

  pageLimitChanged: PropTypes.func,
  pageChanged: PropTypes.func,

  success: PropTypes.bool,
  isSuccessRefresh: PropTypes.bool,
  resetSuccessAction: PropTypes.func,

  searchData: PropTypes.func,
  onCloseReset: PropTypes.func,
  fetchSessionById: PropTypes.func,

  objectModeDisplay: PropTypes.object,
}
export default GestionSessions
